export default __webpack_public_path__ + "static/media/todo-es-posible-2.dc92fad3.png";